module.exports = __webpack_public_path__ + "img/shangpin_pic.b65f0ac6.png";